import { useEffect, useState } from "react";

/**
 * The REST API will always return an APIResponse if the status is 200
 * the response may contain a "refuse" field, which meand that the API
 * refused to complete the requested action, but is working as intended
 * (so not an error)
 */
export interface PublicAPIResponse<T> {
  data: T,
  refuse?: PublicAPIRefusal
}
export interface PublicAPIRefusal {
  reason: string,
  data: any
}


const search_endpoint = '/wp-json/superlok-search/v1/public';


/**
 * A simple wrapper for calls to the REST API
 */
export async function apiPublic<DATA = any>(endpoint: string | URL | globalThis.Request, init?: RequestInit): Promise<PublicAPIResponse<DATA>> {
  
  init = init || {};

  const default_post_headers: HeadersInit = ['POST', 'PUT', 'PATCH', 'DELETE'].includes(init.method || "") 
    ? {
      'Content-Type': 'application/json',
    } : {};

  init.headers = {
    ...default_post_headers,
    ...init.headers, 
  };

  try {
    const resp = await fetch(`${search_endpoint}${endpoint}`, init);

    if (resp.status !== 200) {
      throw resp;
    }

    const ret: PublicAPIResponse<DATA> = await resp.json();
    return ret;

  } catch (e: any) {
    console.error(e);
    throw e;
  }
}

